
import React, { useState, useEffect, useRef } from "react";

import {  
  Share2,
  Bookmark,
  UserRound,
  MoreVertical,
  Trash2,
  Copy,
  X,
  Check,
  ArchiveRestore,
  ArrowRight,
} from "lucide-react";


import photolg from "../../assets/img/photo-1.jpg";
import userimg from "../../assets/img/user-img.png";
import survayimg1 from "../../assets/img/surveysicon.png";
import survayimg2 from "../../assets/img/sideimg.png";
import survayimg3 from "../../assets/img/survay-1.jpg";

import star from "../../assets/img/star.svg";
import RedButton from "../RedButton";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { archiveSurvey } from "../../service/mySurvey";
import { SurveyService } from "../../service/saveSurvey";


const DraftSurvey = ({ surveys = [], loading, hasMore, onLoadMore, onRefresh, onSwitchTab }) => { 
    const navigate = useNavigate();

    const [activeToggleMenu, setActiveToggleMenu] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const menuRef = useRef(null);

    const formatDate = (dateString) => {
      if (!dateString) return "";
      return new Date(dateString).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };

    
    useEffect(() => {
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveToggleMenu(null);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
    }, []);

   
    const handleArchive = async (surveyId, surveyTitle) => {
        if (submitting) return;
        try {
            setSubmitting(true);
            const response = await archiveSurvey(surveyId);
            if (response && response.data && response.data.success) {
                toast.success(
                  <div>
                    <div className="fw-bold">Survey Archived Successfully</div>
                    <div>{surveyTitle || "Survey"} has been moved to Archived Surveys.</div>
                    <button
                      type="button"
                      className="survey-toast-link bg-transparent p-0 mt-2"
                      onClick={() => onSwitchTab && onSwitchTab("archivedSurveys")}
                    >
                      View Archived Surveys
                    </button>
                  </div>
                );
                if (onSwitchTab) onSwitchTab("archivedSurveys");
                if (onRefresh) onRefresh();
            } else {
                toast.error(response.data.message || "Failed to archive survey");
            }
        } catch (error) {
            console.error("Error archiving survey:", error);
            toast.error("An error occurred while archiving the survey.");
        } finally {
            setSubmitting(false);
        }
    };

    const handleReviewAndPublish = async (surveyId) => {
      try {
        const response = await SurveyService.getSurveyPreview(surveyId);
        const previewData = response?.data?.data;
        if (!previewData?.survey) throw new Error("Survey details are unavailable.");
        navigate("/edit-survey/step-1", {
          state: {
            editData: previewData.survey,
            questions: previewData.questions || [],
            isEdit: true,
            previewData,
          },
        });
      } catch (error) {
        toast.error(error?.response?.data?.message || error.message || "Unable to open this draft.");
      }
    };

    

   
    return (
        <>


        {loading && surveys.length === 0 ? (
          <div className="d-flex justify-content-center my-4">
             <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
             </div>
          </div>
        ) : null}

        {surveys.map((item) => (
            <div className="sr-result-card mb-3" key={item.id}>            

                <div className="row g-3 align-items-center">
                    <div className="col-12 col-sm-auto">
                    <img src={item.survayimage || survayimg1} className="rounded-4 border" style={{width: "70px", height: "64px", }} />
                    </div>

                    <div className="col-12 col-sm draft-survey-heading">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div className="draft-survey-title">
                                <h2 className="sr-result-title">{item.survey_title}</h2> 
                                <p className="sr-result-copy mt-1">Last Edited: {formatDate(item.updated_on)} </p>                       
                            </div>

                            <div className="d-flex gap-2 justify-content-md-end position-relative">

                            {item.parent_survey_id && (
                              <div className="position-relative">                            
                                  <div className="user-status draft" style={{ backgroundColor: "#EBF5FF", color: "#0E69E2" }}>
                                      <span>Clone</span>
                                  </div>
                              </div>
                            )}

                            <div className="position-relative">                            
                                <div className={`user-status draft`}>
                                    {/* <span className="status-dot"></span> */}
                                    <span>Draft</span>
                                </div>
                            </div>

                            <button
                                type="button"
                                className="text-black border-0 bg-transparent"
                                onClick={() => setActiveToggleMenu(activeToggleMenu === item.id ? null : item.id)}
                            >
                                <MoreVertical size={20} />
                            </button>

                            {activeToggleMenu === item.id && (
                                <div className="cs-question-menu" ref={menuRef}>
                                <div className="d-flex gap-1 flex-column w-100">                                    
                                        <button className="cs-action-link" onClick={() => handleArchive(item.id, item.survey_title)}>
                                            <ArchiveRestore size={16} />
                                            <span>Archive</span>
                                        </button>
                                </div>
                                </div>
                            )}
                            </div>   

                        </div>
                    </div>  

                    <div className="col-12 mt-20 border-top pt20px">                    
                        <div className="draft-survey-footer">

                             <div className="draft-survey-details">
                                
                                <div className="flex-fill border-end px-2 px-sm-4">                        
                                    <div className="fw-bold ft-16 graytext">{item.question_count ? `#${item.question_count}` : "#2"}</div>
                                    <div className="ft-12 color858c95">Questions</div>
                                </div>
                            
                                <div className="flex-fill border-end px-2 px-sm-4">                        
                                    <div className="fw-bold ft-16 graytext">{item.industry_name || (item.industry && !/^\d+$/.test(String(item.industry)) ? item.industry : "—")}</div>
                                    <div className="ft-12 color858c95">Industry</div>
                                </div>
                            
                                <div className="flex-fill px-2 px-sm-4">                        
                                    <div className="fw-bold ft-16 graytext">{item.country_name || (item.country && !/^\d+$/.test(String(item.country)) ? item.country : "—")}</div>
                                    <div className="ft-12 color858c95">Country</div>
                                </div>                            
                                    
                            </div>  
                        
                            <div className="draft-survey-action">
                                <button type="button" onClick={() => handleReviewAndPublish(item.id)} className="redhoverbtn w-24 ft-14 fw-bold text-red px-4 py-3 bgwhite rounded-2 cursor-target text-center  border-1 tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105" style={{ borderColor: "#c72430" }}>Review and Publish</button>
                            </div>

                        </div>  
                    </div> 
                </div> 




            </div>
        ))}

        



        {hasMore && (
            <div className="d-flex justify-content-center my-4">
                <button
                    className="redhoverbtn px-4 py-2 bgwhite rounded-2 border border-1"
                    onClick={onLoadMore}
                    disabled={loading}
                >
                    {loading ? "Loading..." : "Load More"}
                </button>
            </div>
        )}
              
        </>
    );
};

export default DraftSurvey;
